import {BASE_URL} from 'shared/variables';

export const CLIENT_ID = window.CLIENT_ID || '';
export const GROUP_ENABLED = window.GROUP_ENABLED;
export const SIGNIN_CALLBACK_URI = `${BASE_URL}/SignIn/Callback`;
export const SIGNIN_SILENT_RENEW_URI = `${BASE_URL}/SignIn/SilentRenew`;
export const SIGNIN_RESPONSE_TYPE = "id_token token";
export const SIGNIN_SCOPES = "openid profile USBC-REGISTRATION-API USBC-PROFILE REGISTRATION_APIKEY_149CA60A-28F9-4DD8-BA65-2252B376AFD6";
export const POST_LOGOUT_REDIRECT_URI = `${BASE_URL}/`;
export const SILENT_RENEWAL_SECONDS_BEFORE_EXPIRES = 120;



// WEBPACK FOOTER //
// ./src/features/shared/auth/variables.js